import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { ModalDialog, Button } from '@common/ui/components';

type Props = {
  onClose: () => void;
  onClick: () => void;
  isOpen: boolean;
  message: string;
};

function CancelButtonModal({ isOpen, onClose, onClick, message }: Props) {
  const { t } = useTranslation('translation');
  return (
    <ModalDialog
      onClose={onClose}
      isOpen={isOpen}
      footer={
        <S_ButtonBox>
          <Button onClick={onClose} label={t('str_cancel', '취소')} line />
          <Button onClick={onClick} label={t('str_confirm', '확인')} />
        </S_ButtonBox>
      }
    >
      <span>
        {message.split('\n').map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </span>
    </ModalDialog>
  );
}

const S_ButtonBox = styled.div`
  align-items: center;
  display: flex;
  gap: 16px;
`;

export default CancelButtonModal;
